<script>
    import { Tooltip } from 'sveltestrap';
    
    import { formatDate, getIsoDateStringAsDate, getTimeClearedDate } from '../../../date-time';

    export let id;
    export let date;
    export let annualDate;
    export let type;
    export let notes;
    export let displayDateOnly = false;
    export let previous = false;
    export let upcoming = false;

    $: today = annualDate.getTime() == getTimeClearedDate().getTime();

    $: future = getIsoDateStringAsDate(date).getTime() > getTimeClearedDate().getTime();

    $: difference = Math.ceil(Math.abs(getTimeClearedDate().getTime() - annualDate.getTime()) / (1000 * 60 * 60 * 24));
</script>

<style>
    .td-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-bottom: 5px;
    }

    .td-date {
        display: flex;
        flex: 0 0 36px;
        height: 36px;
        flex-direction: column;
        align-items: center;
        position: relative;
        background-color: white;
        border: 1px solid #b2b4b5;
        margin-right: 5px;
        cursor: default;
    }

    .td-date-item:first-of-type {
        font-size: 15px;
        line-height: 17px;
        padding-top: 2px;
    }

    .td-date-item:last-of-type {
        padding-bottom: 2px;
    }

    .td-date.previous, .td-date.upcoming {
        color: white;
        border: none;
    }

    .td-date.previous {
        background-color: #b2b4b5;
    }

    .td-date.upcoming {
        background-color: #0097B5;
    }

    .td-date img {
        position: absolute;
        top: -3px;
        height: 12px;
        width: 12px;
        right: -5px;
        background: white;
        border-radius: 8px;
    }

    .td-date.today {
        background-color: #dc3545;
    }

    .td-details {
        display: flex;
        flex-direction: column;
        overflow: auto;
    }

    .td-details.notes-long {
        cursor: default;
    }

    .td-detail {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .td-detail:first-of-type {
        font-size: 13px;
        line-height: 17px;
    }

    .td-date-item:last-of-type, .td-detail:last-of-type {
        font-size: 11px;
        line-height: 13px;  
    }
</style>

<div class="td-row">
    <div class="td-date" id={`${id}-date`} class:previous class:upcoming class:today>
        <span class="td-date-item">
            {annualDate.toLocaleString('default', { day : 'numeric' })}
            {#if future}
                <img src="/assets/arrow/arrow-right-circle.svg" alt="future date"/>
            {/if}
        </span>
        <span class="td-date-item">
            {annualDate.toLocaleString('default', { month : 'short' })}
        </span>
    </div>
    <Tooltip target={`${id}-date`} placement="bottom">
        {formatDate(date)}
    
        {#if upcoming}
            {#if today}
                (Today)
            {:else if difference == 1}
                (Tomorrow)
            {:else}
                (in {difference} days)
            {/if}
        {:else if previous}
            {#if difference == 1}
                (Yesterday)
            {:else}
                ({difference} days ago)
            {/if}
        {/if}
    </Tooltip>
    {#if !displayDateOnly}
        <div class="td-details" id={`${id}-details`} class:notes-long={notes && notes.length > 30}>
            <span class="td-detail">{type}</span>
            <span class="td-detail">
                {#if notes && notes != "null"}
                    {notes}
                {/if}
            </span>
        </div>
        {#if notes && notes.length > 30}
            <Tooltip target={`${id}-details`} placement="bottom">
                {notes}
            </Tooltip>
        {/if}
    {/if}
</div>

